import { FC } from "react";
import { Tooltip } from "antd";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import { CostAndMarginsChart, CostAndMarginsChartProps } from "./CostAndMarginsChart";
import { CostAndMargins as CostAndMarginsType } from "../../../../types/IntelligenceTypes";
import { GenericCard } from "../../../../common/components/GenericCard";
import styles from "./CostAndMargins.module.less";

export interface CostAndMarginProps extends CostAndMarginsChartProps {
    data?: CostAndMarginsType;
}

export const CostAndMargins: FC<CostAndMarginProps> = ({ incomes, data }) => {
    const points = data?.marginTrends.concat(data?.industryComparison);

    return (
        <GenericCard size="larger" className={styles.card}>
            <div className={styles.content}>
                <div className={styles.titleRow}>
                    <div className={styles.title}>Cost of goods sold and margins</div>
                    <Tooltip title="This metric evaluates the efficiency of vendor's production and pricing strategies by analyzing the cost of goods sold (COGS) and profit margins. Optimizing these factors is crucial for maintaining profitability and competitive pricing.">
                        <SvgIcon name="help" size={12} color="#1890FF" />
                    </Tooltip>
                </div>
                {incomes?.quarterly.length ? (
                    <div className={styles.contentMain}>
                        <div className={styles.chart}>
                            <CostAndMarginsChart incomes={incomes} />
                        </div>
                    </div>
                ) : null}
                <ul className={styles.points}>{points?.map((p) => <li key={p}>{p}</li>)}</ul>
            </div>
        </GenericCard>
    );
};
